import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { api } from 'helpers/axios';
import { errorMessage } from 'helpers/common';
import * as Sentry from "@sentry/react";

const fetchProjects = createAsyncThunk('fetchProjects', async (_, { getState, rejectWithValue }) => {
  try {
    const { data, status } = await api.get('/projects');
    if (status === 200) return data;
  } catch (err) {
    Sentry.captureException(err);
    return rejectWithValue(errorMessage(err, 'fetch projects'));
  }
});

export const projectsSlice = createSlice({
  name: 'projects',
  initialState: {
    data: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjects.fulfilled, (state, action) => {
        state.data = action.payload.data;
      });
  }
});

export const getProjects = (state) => state.projects.data;

export { fetchProjects };

export default projectsSlice.reducer;
